/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerSubscriptionBody
 */
export interface CustomerSubscriptionBody {
    /**
     * 
     * @type {string}
     * @memberof CustomerSubscriptionBody
     */
    priceId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerSubscriptionBody
     */
    paymentMethodId: string;
}

/**
 * Check if a given object implements the CustomerSubscriptionBody interface.
 */
export function instanceOfCustomerSubscriptionBody(value: object): value is CustomerSubscriptionBody {
    if (!('priceId' in value) || value['priceId'] === undefined) return false;
    if (!('paymentMethodId' in value) || value['paymentMethodId'] === undefined) return false;
    return true;
}

export function CustomerSubscriptionBodyFromJSON(json: any): CustomerSubscriptionBody {
    return CustomerSubscriptionBodyFromJSONTyped(json, false);
}

export function CustomerSubscriptionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerSubscriptionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'priceId': json['priceId'],
        'paymentMethodId': json['paymentMethodId'],
    };
}

export function CustomerSubscriptionBodyToJSON(json: any): CustomerSubscriptionBody {
    return CustomerSubscriptionBodyToJSONTyped(json, false);
}

export function CustomerSubscriptionBodyToJSONTyped(value?: CustomerSubscriptionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceId': value['priceId'],
        'paymentMethodId': value['paymentMethodId'],
    };
}

